var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoTripFound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 174,
    viewBox: "0 0 220 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.211 57.5312C132.597 57.5312 116.704 56.9226 101.836 52.9485C87.2486 49.064 73.8548 41.5276 61.916 32.8098C54.0999 27.1352 46.9926 22.6241 36.8446 23.3044C26.9084 23.8264 17.4112 27.404 9.75848 33.508C-3.15033 44.2486 -1.21028 64.3515 3.95697 78.4755C11.7172 99.7419 35.3336 114.474 55.4057 124.105C78.593 135.222 104.075 141.666 129.613 145.39C151.998 148.648 180.763 151.028 200.163 136.994C217.978 124.105 222.866 94.6759 218.501 74.8057C217.443 68.9304 214.186 63.6279 209.341 59.8941C196.824 51.1226 178.151 56.9763 164.086 57.2806C158.863 57.388 153.546 57.5133 148.211 57.5312Z",
    fill: "#D6E7EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.006 174C147.827 174 178.487 172.165 178.487 169.901C178.487 167.637 147.827 165.801 110.006 165.801C72.186 165.801 41.5264 167.637 41.5264 169.901C41.5264 172.165 72.186 174 110.006 174Z",
    fill: "#D6E7EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8096 121.992C12.8192 121.992 13.6377 121.207 13.6377 120.238C13.6377 119.269 12.8192 118.483 11.8096 118.483C10.7999 118.483 9.98145 119.269 9.98145 120.238C9.98145 121.207 10.7999 121.992 11.8096 121.992Z",
    fill: "#798F93"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192.606 151.244V158.959",
    stroke: "#798F93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M188.595 155.11H196.616",
    stroke: "#798F93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M188.525 42.7781C189.535 42.7781 190.354 41.9927 190.354 41.0238C190.354 40.055 189.535 39.2695 188.525 39.2695C187.516 39.2695 186.697 40.055 186.697 41.0238C186.697 41.9927 187.516 42.7781 188.525 42.7781Z",
    fill: "#798F93"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2861 14.3177C55.2958 14.3177 56.1143 13.5323 56.1143 12.5634C56.1143 11.5945 55.2958 10.8091 54.2861 10.8091C53.2765 10.8091 52.458 11.5945 52.458 12.5634C52.458 13.5323 53.2765 14.3177 54.2861 14.3177Z",
    fill: "#798F93"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M162.07 0.945312V8.64277",
    stroke: "#798F93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M158.061 4.79395H166.082",
    stroke: "#798F93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9766 3V10.6975",
    stroke: "#798F93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9668 6.84863H48.0068",
    stroke: "#798F93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4943_688)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 77.5,
    r: 66,
    fill: "#F9F9F9",
    stroke: "#798F93",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.5858,
    y1: 127.586,
    x2: 167.586,
    y2: 33.5858,
    stroke: "#798F93",
    strokeWidth: 4
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M175.276 97.7386C159.595 70.5676 134.618 49.9842 104.95 39.7858C101.665 38.6575 98.0515 39.0164 95.054 40.7704L67.3483 56.978C65.0346 58.3313 63.8634 60.8021 64.0143 63.2444L64 63.2381V71.7655C64 76.1573 65.3613 80.4402 67.8973 84.0259C82.4455 104.597 125.974 123.482 153.512 121.646C168.514 120.646 181 107.656 181 107.656L175.276 97.7386Z",
    fill: "#93ACB0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3483 56.978L95.054 40.7704C98.0515 39.0164 101.665 38.6575 104.95 39.7858C134.617 49.9842 159.595 70.5676 175.276 97.7386L181 107.656H155.161C120.93 107.656 88.3458 92.955 65.6933 67.2898C62.8761 64.0977 63.6733 59.1284 67.3483 56.978Z",
    fill: "#EDEDED"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128.508 57.4844L132.895 59.799C132.928 59.5374 132.944 59.2741 132.94 59.0081L128.508 57.4844Z",
    fill: "#304E75"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M149.677 75.4252L145.519 70.6567C146.375 73.1981 146.859 77.2435 144.196 81.9692C141.48 86.7912 134.175 89.129 130.064 90.0931C126.344 90.9661 122.316 91.4204 118.731 91.4204C117.584 91.4204 116.486 91.3722 115.454 91.2776L124.498 94.6428C131.841 97.3743 140.02 96.6825 146.8 92.7567C152.996 89.1692 154.381 80.8212 149.677 75.4252Z",
    fill: "#82A5B9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.944 56.2873L122.5 61.1486L128.901 64.9771C128.62 65.1654 130.799 63.5748 130.799 63.5748C131.427 63.0668 131.929 62.4393 132.289 61.744L121.77 56.1953L121.944 56.2873Z",
    fill: "#627681"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M105.197 70.9657L106.066 71.0014H106.067C113.334 71.3058 119.9 69.8017 126.729 66.2659C127.461 65.8875 128.186 65.4554 128.901 64.977L122.5 61.1484L105.197 70.9657Z",
    fill: "#808E9A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.473 47.501L104.315 46.8779L76.1738 63.1257L80.5861 66.8552L106.024 52.3212L105.473 47.501Z",
    fill: "#525E65"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5797 41.6525C94.4109 41.5623 94.2815 41.4284 94.1914 41.2749L68.2646 56.4417L76.1734 63.1258L104.315 46.878L94.5797 41.6525Z",
    fill: "#808E9A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M113.504 56.6398L117.852 54.1288L105.473 47.501L106.023 52.3212L113.504 56.6398Z",
    fill: "#627681"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M106.023 52.3213L80.5859 66.8552L84.4368 70.1098L84.5323 70.1143L106.023 57.7057L108.841 59.3321L113.503 56.6399L106.023 52.3213Z",
    fill: "#808E9A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M106.023 57.7056V60.9575L108.841 59.332L106.023 57.7056Z",
    fill: "#627681"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7899 70.3302L106.023 60.9575V57.7056L84.5322 70.1141L89.7899 70.3302Z",
    fill: "#525E65"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M122.5 61.1486L121.945 56.2873L120.815 55.6919L95.082 70.549L105.197 70.9658L122.5 61.1486Z",
    fill: "#525E65"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0825 70.549L120.818 55.6937L117.852 54.1289L89.79 70.3303L95.0825 70.549Z",
    fill: "#808E9A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M105.334 72.9759L86.7568 72.2109C98.6513 82.8583 107.68 86.9627 111.46 88.3507L105.334 72.9759Z",
    fill: "#507A81"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M144.129 67.8238C144.109 67.7971 144.088 67.7712 144.065 67.7462L134.595 57.3264C134.595 57.3255 134.594 57.3255 134.593 57.3246C134.589 57.321 134.587 57.3175 134.583 57.313C134.294 57.0006 116.975 51.4011 116.975 51.4011L95.5282 39.8878C95.0408 39.6263 94.4338 39.8093 94.1714 40.2966C93.9098 40.784 94.0928 41.3919 94.5802 41.6534L116.098 53.2051C116.1 53.2051 116.101 53.206 116.103 53.2069C116.104 53.2069 116.104 53.2078 116.105 53.2078L132.29 61.745C131.929 62.4403 131.427 63.067 130.799 63.5758L130.73 63.6311C129.44 64.6737 128.093 65.5601 126.729 66.2671C119.899 69.8019 113.334 71.3069 106.067 71.0025C106.066 71.0025 106.066 71.0025 106.065 71.0025L84.4372 70.1108L67.9947 56.2142C67.5725 55.8571 66.9396 55.9098 66.5835 56.3329C66.2264 56.7551 66.2791 57.3871 66.7013 57.7442L83.3874 71.847C100.656 87.9555 112.456 90.8147 112.951 90.9289C112.956 90.9298 112.961 90.9307 112.968 90.9316C112.972 90.9325 112.977 90.9343 112.981 90.9352C114.639 91.2619 116.607 91.4216 118.731 91.4216C122.316 91.4216 126.344 90.9673 130.064 90.0943C134.176 89.1302 141.48 86.7924 144.197 81.9704C148.644 74.0768 144.315 68.0747 144.129 67.8238ZM128.508 57.4844L132.94 59.0081C132.944 59.2741 132.928 59.5375 132.895 59.7981L128.508 57.4844ZM86.7571 72.2112L105.334 72.9762L111.46 88.351C107.681 86.9629 98.6524 82.8586 86.7571 72.2112Z",
    fill: "#CECECE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M152.481 91.4624C160.357 94.1278 168.511 98.5053 175.03 103.672C167.151 101.015 159.006 96.6219 152.481 91.4624Z",
    fill: "#798F93"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M127.65 68.0449C119.923 72.1377 107.641 73.0401 107.516 73.0392L113.901 89.0657C122.582 90.5296 138.755 87.5464 142.452 80.9864C146.107 74.4978 142.856 69.5026 142.543 69.0491L134.804 60.5352C134.719 60.9859 134.269 64.5395 127.65 68.0449Z",
    fill: "#507A81"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4943_688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 142,
    fill: "white",
    transform: "translate(42 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTripFound);
export default __webpack_public_path__ + "static/media/no-trip-found.4e4f7d0adc739d1a3b084741190c79ed.svg";
export { ForwardRef as ReactComponent };